/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'items';
const componentName = 'gslb-vs';
const prefix = `${moduleName}.${componentName}`;

export const noSubdomainsLabel = `${prefix}.noSubdomainsLabel`;
export const hostAllSubdomainsLabel = `${prefix}.hostAllSubdomainsLabel`;

export const ENGLISH = {
    [noSubdomainsLabel]: 'No Subdomains',
    [hostAllSubdomainsLabel]: 'Host All Subdomains',
};
